var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91363e-06 1.00154C0.000287489 0.448321 0.44884 0 1.00206 0H27.7236C27.9896 0 28.2447 0.105776 28.4326 0.294016C28.6206 0.482257 28.726 0.737512 28.7256 1.00353C28.722 3.44741 28.0948 5.84986 26.9036 7.98365L26.9035 7.98369C25.7135 10.1152 23.9998 11.9081 21.9245 13.1933C21.1347 13.6997 20.4862 14.3984 20.04 15.2237L20.04 15.2238C19.5926 16.0513 19.3631 16.9789 19.373 17.9195C19.3731 17.923 19.3731 17.9266 19.3731 17.9301V23.6619C19.3731 24.1517 19.0189 24.5698 18.5358 24.6503L10.5193 25.9864C10.2288 26.0348 9.93163 25.9529 9.70688 25.7625C9.48213 25.5721 9.35253 25.2925 9.35253 24.9979V17.9568C9.35253 17.9533 9.35254 17.9498 9.35258 17.9462C9.36253 17.0056 9.13302 16.0779 8.68568 15.2505C8.23941 14.4252 7.59097 13.7266 6.80108 13.22C4.72159 11.9322 3.00536 10.1348 1.81512 7.99788L2.69054 7.51028L1.81511 7.99788C0.623579 5.85863 -0.00126199 3.45026 1.91363e-06 1.00154ZM2.04424 2.00411C2.18631 3.76269 2.70368 5.47457 3.56596 7.02268C4.59124 8.86344 6.07012 10.4115 7.86213 11.5198C7.86642 11.5225 7.87068 11.5251 7.87493 11.5279C8.95377 12.2178 9.83947 13.1708 10.4486 14.2973L10.4486 14.2973C11.0568 15.4222 11.3692 16.6833 11.3566 17.9619V23.815L17.369 22.813V17.9352C17.3564 16.6566 17.6688 15.3956 18.2771 14.2706C18.8861 13.1441 19.7719 12.1909 20.8507 11.5011C20.855 11.4984 20.8592 11.4957 20.8635 11.4931C22.6519 10.387 24.1285 8.84283 25.1537 7.00674C26.0151 5.46373 26.5337 3.75751 26.6792 2.00411H2.04424Z",
    fill: "#1B224C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilterIcon);
export default __webpack_public_path__ + "static/media/tableFilterIcon.72b020041c35bdcfc69f1e642aca0d2d.svg";
export { ForwardRef as ReactComponent };